
const { ccclass, property, disallowMultiple, menu } = cc._decorator;

@ccclass
@disallowMultiple
@menu('Framework/渲染组件/RenderList')
export default class RenderList extends cc.Component {



    start() {

    }

    protected onEnable(): void {
        this.refreshChildNodeInfo();
    }

    /**
     * 将节点的所有子节点按层级优先展开,并缓存到this.node._renderChildren
     */
    refreshChildNodeInfo(isTest = false) {
        if (cc.sys.isNative) {
            return;
        }
        // return;
        const levels = [];
        let level = 0;
        this.node['_renderChildren'] = [];
        const dfs = function (node) {
            if (!cc.isValid(node)) return;
            levels[level] = levels[level] || [];
            levels[level].push(node);
            if (node.children.length) {
                for (let child of node.children) {
                    level++;
                    dfs(child);
                }
            }
        }

        for (let child of this.node.children) {
            dfs(child);
            level = 0;
        }

        if (isTest) {
            cc.log('levels ==', levels.length, levels);
            cc.log('_renderChildren == ', [].concat(...levels));
        }
        this.node['_renderChildren'] = [].concat(...levels);
    }

    // update (dt) {}
}
